import { gql } from "@apollo/client";

export const UPDATE_CONDICION_GENERAL = gql`
    mutation UpdateCondicionGeneralRI(
        $screen: Int!
        $input: AddCondicionGeneralInput!)
    {
        updateCondicionGeneralRI(
            screen: $screen
            input: $input
        ){
            idCondicionGeneralRI
        }
    }
`;